import React from "react";
import ExpensesDetails from "../../components/common/create-profile/expenses";
import CreateProfileLayout from "../layout";

const Expenses = () => {
  return (
    <>
      <CreateProfileLayout>
        <ExpensesDetails />
      </CreateProfileLayout>
    </>
  );
};

export default Expenses;
